import { NOC_MODE_FILTERS, NOC_MODE_TRENDS } from '@utils/constants';

export const NocViewItems = [
  { value: NOC_MODE_FILTERS, label: 'Real-Time: Filters' },
  { value: NOC_MODE_TRENDS, label: 'Real-Time: Trends' },
];

export const NocFilterItems = [
  { key: 'saved-filter', label: 'Add saved filters' },
  { key: 'filter-from-trends', label: 'Add filters from trends' },
];

export const kebabItems = [
  // { key: 'export', displayValue: 'Export' },
  // { key: 'new', displayValue: 'New' },
  // { key: 'clone', displayValue: 'Clone' },
  { key: 'threshold', label: 'Threshold' },
  { key: 'autosort', label: '', disabled: true },
];

